<template>
  <div>
    <el-form ref="formRef" :model="priceForm" label-width="88px">
      <el-form-item label="名称：">
        <el-input type="text" v-model="priceForm.name" placeholder="输入标签名称" style="width:24em;"/>
      </el-form-item>
      <el-form-item label="价格：">
        <el-input type="text" v-model="priceForm.price" placeholder="输入标签价格" style="width:24em;"/>
      </el-form-item>
      <el-form-item label="标签：">
        <el-input type="text" v-model="priceForm.tag" placeholder="输入标签标签" style="width:24em;"/>
      </el-form-item>
    </el-form>
    <div class="dialog-footer">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit" v-loading="loading">确定</el-button>
    </div>
  </div>

</template>

<script>
import { postFormData } from "@/api/api"
import { addOrUpdateServicePrice } from "@/api/url";
import { moneyReg } from "../../../assets/shared/reg-constant";

export default {
  name: "ServicePriceDialog",
  props: {
    value: Object
  },
  data() {
    return {
      priceForm: this.value.priceForm,
      idx: this.value.ids,
      urlId: this.value.urlId,
      loading: false,
    }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },

    //更改或添加
    headImgUpdate() {
      this.$refs.headImg.click();
    },

    //选取图片
    headImgChanged(e) {
      if(e.target.files[0]) {
        this.files = e.target.files[0];
        var windowURL = window.URL || window.webkitURL;
        this.src = windowURL.createObjectURL(this.files);
      }
    },

    summit() {
      if(!this.priceForm.name) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '名称不能为空',
          type: 'warning'
        });
        return false
      }
      if(!this.priceForm.price) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '价格不能为空',
          type: 'warning'
        });
        return false
      } else if (!moneyReg.test(this.priceForm.price)) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '价格不正确',
          type: 'warning'
        });
        return false
      }
      this.loading = true
      let param = {};
      param['id'] = this.priceForm.id?this.priceForm.id:0;
      param['name'] = this.priceForm.name;
      param['price'] = this.priceForm.price;
      param['tag'] = this.priceForm.tag;
      param['urlId'] = this.urlId;
      postFormData(addOrUpdateServicePrice, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm')
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
        this.loading = false
      }).catch(()=>{
        this.loading = false
      })
    }
  },
  mounted() {
  }
}
</script>

<style scoped>
.add {
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  border: 1px dashed #ececec;
  font-size: 30px;
  cursor: pointer;
  float: left;
}
</style>
